import React from 'react';
import { translate } from 'react-i18next';

import Modal from '../../../common/Modal';
import Button from '../../../common/Button';
import Form from '../../../user/edit/Form';
import * as API from '../../../core/api';
import { catchFormErrors } from '../../../utils/form-errors';
import i18n from '../../../core/i18n';

class Edit extends React.Component {
  state = { isModalOpen: false };

  handleModalOpen = () => this.setState({ isModalOpen: true });
  handleModalClose = () => this.setState({ isModalOpen: false });

  handleSubmit = (formValues) => {
    const { onSuccess } = this.props;

    return API.post('invites', {
      ...formValues,
      urls:
        formValues.urls && formValues.urls.split(',').map((url) => url.trim()),
    })
      .then((invite) => {
        const isAvatarSelected = typeof formValues.avatarUrl === 'object';
        if (!isAvatarSelected) {
          return invite;
        }

        const data = new FormData();
        data.append('avatar', formValues.avatarUrl, formValues.avatarUrl.name);

        // If avatar upload only fails, resolve the promise as a success,
        // but notify the user there was an issue.
        return new Promise((resolve, reject) => {
          API.post(`invites/${invite.code}/avatar`, data)
            .then(resolve)
            .catch((err) => {
              alert(
                i18n.t('admin.inviteAvatarUploadEdgeCase', {
                  error: JSON.stringify(err),
                })
              );
              resolve();
            });
        });
      })
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  render() {
    const { t } = this.props;
    const { isModalOpen } = this.state;

    return (
      <React.Fragment>
        <Button onClick={this.handleModalOpen} styleType="outline">
          {t('admin.addNewMemberBtn')}
        </Button>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={this.handleModalClose}
          title={t('admin.addNewMemberBtn')}
        >
          <Form
            okButtonText={t('admin.edit.sentInvite')}
            onSubmit={this.handleSubmit}
            enableEmailInput
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default translate()(Edit);



// WEBPACK FOOTER //
// ./src/admin/invites/create/index.js